import { json as jsonLang } from "@codemirror/lang-json";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Alert } from "@mui/material";
import { Button } from "@totalenergiescode/mobility-business-rev-design-system";
import { githubLight } from "@uiw/codemirror-theme-github";
import CodeMirror from "@uiw/react-codemirror";
import React, { useRef } from "react";

import { JsonInputPanelProps } from "@/components/FormEngine/components/JsonInput/types";

import {
  StyledActionsContainer,
  StyledCodeMirrorContainer,
  StyledContentContainer,
  StyledSectionPaper,
} from "./styles";

export const JsonInputPanel: React.FC<JsonInputPanelProps> = ({
  raw,
  setRaw,
  applyJson,
  loadFromFile,
  error,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    loadFromFile(event.target.files?.[0] ?? null);
    if (event.target) {
      event.target.value = "";
    }
  };

  return (
    <StyledSectionPaper
      elevation={0}
      variant='outlined'
      aria-labelledby='json-input'
    >
      <StyledContentContainer>
        <StyledActionsContainer>
          <Button
            variant='secondary'
            onClick={handleFileButtonClick}
            leftIcon={<FileUploadIcon color='primary' />}
            buttonText='Charger un fichier'
          />
          <input
            type='file'
            accept='application/json'
            hidden
            ref={fileInputRef}
            onChange={handleFileChange}
          />

          <Button
            variant='primary'
            onClick={applyJson}
            buttonText='Générer le formulaire'
          />
        </StyledActionsContainer>

        {error && (
          <Alert severity='error' role='alert'>
            {error}
          </Alert>
        )}

        <StyledCodeMirrorContainer>
          <CodeMirror
            value={raw}
            height='320px'
            theme={githubLight}
            extensions={[jsonLang()]}
            onChange={(value) => setRaw(value)}
            basicSetup={{
              lineNumbers: true,
              foldGutter: true,
              autocompletion: true,
              highlightActiveLine: true,
            }}
          />
        </StyledCodeMirrorContainer>
      </StyledContentContainer>
    </StyledSectionPaper>
  );
};
